import * as z from 'zod';
import { tSettingSchema } from './ide-setting-schema';
import { tSettingOptionSchema } from './setting-option-schema';
export const tIdeSettingsFormValuesSchema = tSettingOptionSchema.extend({
    content: z.array(tSettingSchema).min(1, { message: 'Please add at least one setting' })
});
